import { render, staticRenderFns } from "./UserViewInfo.vue?vue&type=template&id=71a3233f&scoped=true&"
import script from "./UserViewInfo.vue?vue&type=script&lang=js&"
export * from "./UserViewInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserViewInfo.vue?vue&type=style&index=0&id=71a3233f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3233f",
  null
  
)

export default component.exports